import { render, staticRenderFns } from "./Caja.vue?vue&type=template&id=0ea0ab00"
import script from "./Caja.vue?vue&type=script&lang=js"
export * from "./Caja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports